<template>
  <section>
    <div class="my-spacebetween">
      <div class="mx-auto max-w-content px-sidespacing">
        <div class="flex flex-col gap-20">
          <h2 class="animate-fade text-6xl font-extrabold">
            {{ registerData?.heading }}
          </h2>
          <div
            class="animate-slide-left flex overflow-hidden rounded-2xl border-2 m:flex-col"
          >
            <!--maybe mobile wrong-->
            <div
              v-for="(card, index) in registerData?.registerCards"
              :key="index"
              class="flex overflow-hidden transition-all duration-500 ease-in-out m:w-full m:flex-col md:h-[70vh]"
              :class="[
                isActiveTab(index)
                  ? 'w-full m:max-h-[100svh]'
                  : 'w-20 shrink-0 m:max-h-16',
                index !== 0 ? 'm:border-t-2 md:border-l-2' : '',
              ]"
            >
              <!--col left-->
              <div
                class="flex h-full w-20 shrink-0 flex-col items-center justify-between py-8 m:relative m:h-16 m:w-full m:flex-row m:justify-start m:pl-6"
                :class="{ 'cursor-pointer': !isActiveTab(index) }"
                @click="setActiveTab(index)"
              >
                <div class="text-2xl font-extrabold">
                  {{ (index + 1).toString().padStart(2, '0') }}
                </div>
                <div
                  class="text-2xl font-extrabold m:hidden"
                  style="writing-mode: sideways-lr"
                >
                  {{ card.heading }}
                </div>
                <div
                  class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-2xl font-extrabold md:hidden"
                >
                  {{ card.heading }}
                </div>
              </div>

              <!--min-w-[100vw] to hide the scrolling bar-->
              <div class="h-full overflow-auto md:min-w-[100vw]">
                <div
                  class="flex h-full w-[40rem] flex-col px-12 py-16 m:w-full m:px-6 m:py-4"
                >
                  <h4
                    class="text-primary mb-6 text-4xl font-extrabold uppercase m:mb-5"
                  >
                    {{ card.heading }}
                  </h4>
                  <div class="richText" v-html="card.text"></div>
                  <div
                    class="mt-12 h-[25rem] w-full pb-16 m:mt-6 m:h-auto m:pb-8"
                  >
                    <img
                      class="aspect-video size-full rounded-2xl object-cover"
                      :src="card.image.src"
                      :alt="card.image.alt"
                      :style="card.image.focalStyle || undefined"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

interface CardImage {
  src: string;
  alt?: string;
  focalStyle?: string;
}
interface RegisterCard {
  heading: string;
  text: string;
  image: CardImage;
}
interface RegisterData {
  heading: string;
  registerCards: RegisterCard[];
}
const props = defineProps<{
  registerData?: RegisterData;
}>();

const activeTab = ref(0);

const isActiveTab = (index: number) => activeTab.value === index;
const setActiveTab = (index: number) => {
  activeTab.value = index;
};
</script>
